/**
 * Created by tmorone on 2/10/2016.
 */

var Marionette = require('backbone.marionette');
var md5 = require('md5-component');

const hash_key = '4472a6366b0d41c79f900a1d3604b8ca';

var Hash = Marionette.Object.extend({
    MD5 : function(slug){
        return md5(slug + hash_key);
    }
});

module.exports = new Hash();
